<template>
  <div
    class="bluerect fpMultiselectClass"
    v-on:drop="onDrop"
    v-bind:class="{ highlight: this.isDropTarget }"
  >
    <div>
      <table class="cfg" v-if="options.canDrag">
        <tr
          class="cfg draggable"
          v-bind:class="{
            cfgselected: item.isSelected,
            cfgsent: item.isSent,
            cfgwarn: item.isWarn,
            cfgerror: item.isError
          }"
          v-on:click="onClick(item)"
          v-for="item in itemsToList"
          :key="item.id"
          ref="items"
        >
          <template v-for="(column, index) in columns">
            <td v-if="column != 'iconHead'" class="cfg" v-bind:key="index">
              <drag
                class="fpMultiselectDraggableColumnClass"
                :transfer-data="{ item: item }"
                @dragstart="handleDragStart"
                @dragend="handleDragEnd"
                :content="onTooltip(item, index)"
                v-tippy="{
                  theme: 'translucent',
                  trigger: 'mouseenter focus',
                  placement: 'top-end',
                  arrow: false,
                  flipOnUpdate: true,
                  followCursor: false,
                  size: 'large',
                  zIndex: 19999999,
                  delay: [800, 0],
                  distance: 12,
                  onShow: canShowTooltip(item, index)
                }"
                v-html="getField(item, index)"
              ></drag>
            </td>
            <td v-else v-bind:key="index" class="cfg">
              <drag
                class="fpMultiselectDraggableColumnClass"
                :transfer-data="{ item: item }"
                @dragstart="handleDragStart"
                @dragend="handleDragEnd"
              >
                <i
                  class="fa fpMultiselectIconClass fa-fw"
                  v-bind:class="getField(item, index)"
                >
                </i>
              </drag>
            </td>
          </template>
        </tr>
      </table>

      <table class="cfg" v-else>
        <tr
          class="cfg"
          v-bind:class="{
            cfgselected: item.isSelected,
            cfgsent: item.isSent,
            cfgwarn: item.isWarn
          }"
          v-on:click="onClick(item)"
          v-for="item in items"
          :key="item.id"
          ref="items"
        >
          <template v-for="(column, index) in columns">
            <td
              v-if="column[index] != 'iconHead'"
              v-bind:key="index"
              class="cfg"
              :content="onTooltip(item, index)"
              v-tippy="{
                theme: 'translucent',
                trigger: 'mouseenter focus',
                placement: 'top-end',
                arrow: false,
                flipOnUpdate: true,
                followCursor: false,
                size: 'large',
                zIndex: 19999999,
                delay: [800, 0],
                distance: 12,
                onShow: canShowTooltip(item, index)
              }"
              v-html="getField(item, index)"
            ></td>
            <td v-else v-bind:key="index" class="cfg">
              <i class="fa fa-c" v-bind:class="getField(item, index)"> </i>
            </td>
          </template>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { Drag } from "vue-drag-drop";
import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";
import "tippy.js/themes/material.css";
import "tippy.js/themes/translucent.css";

// <single-select-list v-bind:items="configsArray" v-on:item-selected="onConfigSelected"></single-select-list>
export default {
  name: "multiselect",
  components: {
    Drag
  },
  data: function () {
    return {
      isDropTarget: false,
      isDropDown: false
    };
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    options: {
      type: Object,
      default: function () {
        return {};
      }
    },
    columns: {
      type: Array,
      default: function () {
        return ["name"];
      }
    },
    tooltip: {
      type: Function
    },
    canChangeSelection: Function
  },
  created: function () {
    window.addEventListener("keyup", this.previous);
  },
  computed: {
    itemsToList: function () {
      if (this.isDropDown) {
        return this.items.filter(function (item) {
          return item.isSelected;
        });
      } else {
        return this.items;
      }
    }
  },
  mounted: function () {
    if (this.options.isDroppable) {
      var e = this.$el;
      ["dragenter", "dragover", "dragleave", "drop"].forEach(eventName => {
        e.addEventListener(eventName, this.preventDefaults, false);
      });
      ["dragenter", "dragover"].forEach(eventName => {
        e.addEventListener(eventName, this.highlight, false);
      });
      ["dragleave", "drop"].forEach(eventName => {
        e.addEventListener(eventName, this.unhighlight, false);
      });
    }
  },
  methods: {
    previous() {
      // alert('previous');
    },
    resolve(path, obj) {
      return path.split(".").reduce(function (prev, curr) {
        return prev ? prev[curr] : null;
      }, obj || self);
    },
    getField(item, column) {
      // In case columns are part of sub objects they can be expressed with a . notation
      // for example, if the object has a sub-object it is possible to specify a column as objectname.subobjectproperty
      return this.resolve(this.columns[column], item);
    },
    canShowTooltip(item, index) {
      return () => {
        return this.onTooltip(item, index) !== undefined;
      };
    },
    onTooltip(item, index) {
      if (this.tooltip) {
        return this.tooltip(item, index, this.columns[index]);
      }
      return undefined;
    },

    clearSelection() {
      this.items.forEach(it => {
        if (it.isSelected) {
          it.isSelected = false;
        }
      });
    },
    highlight() {
      this.isDropTarget = true;
    },
    unhighlight() {
      this.isDropTarget = false;
    },
    preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    }, // preventDefaults
    onDrop(item) {
      this.clearSelection();
      this.$emit("on-drop", item);
    },
    onArrowDown(item) {
      alert(item.id);
    },

    makeVisible() {
      let idx = 0;
      this.items.forEach(it => {
        if (it.isSelected) {
          let idxToScroll = idx;
          this.$nextTick(() => {
            this.$refs.items[idxToScroll].scrollIntoView(false);
          });
          return;
        }
        idx++;
      });
    },

    select(item) {
      if (this.canChangeSelection && !this.canChangeSelection()) return;

      if (this.options.select == "multi" && event.shiftKey) {
        item.isSelected = !item.isSelected;
        if (item.isSelected) this.$emit("item-selected", item);
        else this.$emit("item-unselected", item);
      } else {
        if (item.isSelected && this.options.select != "multi") return;
        this.items.forEach(it => {
          if (it.isSelected) {
            it.isSelected = false;
          }
        });
        item.isSelected = true;
        this.$emit("item-selected", item);
      }
    },

    onClick(item) {
      event.preventDefault();
      event.stopPropagation();
      document.getSelection().removeAllRanges();
      this.select(item);
    },
    handleDragStart(transferData, nativeEvent) {
      // Make the item selected, so if the drag happens and the item is not selected we can drag it anyway
      // This is needed because the drop event will ignore transfer data and just move all selected items
      this.select(transferData.item);
      //transferData.item.isSelected = true;
      var dt = nativeEvent.dataTransfer;
      if (this.options.dragSource) {
        var dto = {
          dragSource: this.options.dragSource,
          id: transferData.item.id,
          name: transferData.item.name
        };
        // we have to use 'text' because other strings fail in Chrome
        dt.setData("text", JSON.stringify(dto));
      }
      this.$emit("item-drag-start", transferData);
    },
    // eslint-disable-next-line
    handleDragEnd(transferData, nativeEvent) {
      this.$emit("item-drag-end", transferData);
    }
  }
};
</script>
<style scoped>
.fpMultiselectClass {
  white-space: nowrap;
  overflow: auto;
  padding-left: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  background: #fff;
  box-shadow: inset 0px 0px 0px 1px rgba(0, 0, 0, 0.15),
    0px 2px 3px 0px rgba(0, 0, 0, 0.1);
}

.fpMultiselectIconClass {
  padding: 0px;
  font-size: 1em;
}

.fpMultiselectDraggableColumnClass {
  margin: 0px;
}

tr.cfgwarn {
  color: #a86424;
}

tr.cfgselected.cfgwarn {
  color: #ffcea0;
}

tr.cfgerror {
  color: #a82424;
}

tr.cfgselected.cfgerror {
  color: #ffa0a0;
}
</style>
